import classNames from 'classnames'
import { Text } from 'components/Text'
import { ErrorProps } from './Form'

export function Error({ message, className, style, render }: ErrorProps) {
  if (!message) {
    return null
  }
  return (
    <Text.Corpus className={classNames('error-box', className)} style={style}>
      {render && message ? render(message) : message}
    </Text.Corpus>
  )
}
